
<div class="title-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="zip-title" cdkFocusInitial>Job Sourcing</div>
    <button mat-button class="toolbar-icon-button" (click)="onCancel()">
        <mat-icon class="material-icons dialog-closeicon">
            close
        </mat-icon>
    </button>
</div>
<div fxLayout="column" class="content-wrapper">
    <div fxLayout="column" fxLayoutAlign="space-between center"  class="tail-container">
        <div  fxLayout="row" fxLayoutAlign="space-between center"  class="title-wrapper">
            <div class="title">Career Portal Website</div>
            <mat-slide-toggle>
            </mat-slide-toggle>
        </div>
        <div class="bottom-content" fxLayout="row"  fxLayoutAlign="space-between center">
            <div class="button-container" fxLayout="row">
                <button mat-button class="snapshot-button">Log</button>
                <button mat-button class="snapshot-button">Screening</button>
            </div>
            <div class="date">
              04/11/2024
            </div>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between start" class="tail-container">
        <div  fxLayout="row" fxLayoutAlign="space-between center" class="title-wrapper">
            <div class="title">Job Portal</div>
            <mat-slide-toggle>
            </mat-slide-toggle>
        </div>
        <div fxLayout="column" fxLayoutGap="8px" class="sub-portal-title">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div>Naukri</div>
                <mat-slide-toggle></mat-slide-toggle>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div>Monster</div>
                <mat-slide-toggle></mat-slide-toggle>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div>Internshala</div>
                <mat-slide-toggle></mat-slide-toggle>
            </div>
       
        </div>
        <div class="bottom-content" fxLayout="row"  fxLayoutAlign="space-between center">
            <div class="button-container" fxLayout="row">
                <button mat-button class="snapshot-button">Log</button>
                <button mat-button class="snapshot-button">Screening</button>
            </div>
            <div class="date">
              04/11/2024
            </div>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between center" class="tail-container">
        <div  fxLayout="row" fxLayoutAlign="space-between center" class="title-wrapper">
            <div class="title">LinkedIn</div>
            <mat-slide-toggle>
            </mat-slide-toggle>
        </div>
        <div class="bottom-content" fxLayout="row"  fxLayoutAlign="space-between center">
            <div class="button-container" fxLayout="row">
                <button mat-button class="snapshot-button">Log</button>
                <button mat-button class="snapshot-button">Screening</button>
            </div>
            <div class="date">
              04/11/2024
            </div>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between center" class="tail-container">
        <div  fxLayout="row" fxLayoutAlign="space-between center" class="title-wrapper">
            <div class="title">Employee Referral</div>
            <mat-slide-toggle>
            </mat-slide-toggle>
        </div>
        <div class="bottom-content" fxLayout="row"  fxLayoutAlign="space-between center">
            <div class="button-container" fxLayout="row">
                <button mat-button class="snapshot-button">Log</button>
                <button mat-button class="snapshot-button">Screening</button>
            </div>
            <div class="date">
              04/11/2024
            </div>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="space-between start" class="tail-container">
        <div  fxLayout="row" fxLayoutAlign="space-between center" class="title-wrapper">
            <div class="title">Vendor</div>
            <mat-slide-toggle>
            </mat-slide-toggle>
        </div>
        <div fxLayout="column" fxLayoutGap="8px" class="sub-portal-title">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div>Vendor One</div>
                <mat-slide-toggle></mat-slide-toggle>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div>Vendor Two</div>
                <mat-slide-toggle></mat-slide-toggle>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div>Vendor three</div>
                <mat-slide-toggle></mat-slide-toggle>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div>Vendor Four</div>
                <mat-slide-toggle></mat-slide-toggle>
            </div>
        </div>
        <div class="bottom-content" fxLayout="row"  fxLayoutAlign="space-between center">
            <div class="button-container" fxLayout="row">
                <button mat-button class="snapshot-button">Log</button>
                <button mat-button class="snapshot-button">Screening</button>
            </div>
            <div class="date">
              04/11/2024
            </div>
        </div>
    </div>
</div>


